<div class="confirm-dialog">
  <div class="dialog-body">
    <div class="message">{{ data.message }}</div>
    <div class="actions uk-text-right">
      <button
        (click)="close(ConfirmActionInputType.CANCEL)"
        class="uk-button uk-button-default uk-modal-close uk-margin-small-right uk-text-capitalize"
        type="button">
        {{ data.dismissButtonMsg }}
      </button>
      @if (data.discardButtonMsg.length) {
        <button
          (click)="close(ConfirmActionInputType.DISCARD)"
          class="uk-button uk-button-default uk-modal-close uk-margin-small-right uk-text-capitalize"
          type="button">
          {{ data.discardButtonMsg }}
        </button>
      }
      <button
        (click)="close(ConfirmActionInputType.CONFIRM)"
        [ngClass]="data.confirmButtonClass"
        class="uk-button uk-modal-close uk-text-capitalize"
        type="button">
        {{ data.confirmButtonMsg }}
      </button>
    </div>
  </div>
</div>
